// Imports: Dependencies
import {all, fork} from 'redux-saga/effects';
// Imports: Redux Sagas
import authSaga from './auth.saga';
import metaSaga from './meta.saga';
// Redux Saga: Root Saga
export default function* rootSaga() {
    yield all([
        fork(authSaga),
        fork(metaSaga),
    ]);
}
